import { PseudoPostType } from 'constants/post';
import { canAcceptAttachmentsFromPseudoType } from './helpers';
import { AttachmentsHandlerFunction } from './types';

export const processReelAttachments =
  ({
    acceptedPseudoTypes = [PseudoPostType.Story, PseudoPostType.Video],
  }: {
    acceptedPseudoTypes?: PseudoPostType[];
  }) =>
  ({
    form,
    pseudoPost,
    attachmentsByPseudoType,
  }: AttachmentsHandlerFunction) => {
    const selectedPseudoPost = PseudoPostType.Reel;

    const canAccept = canAcceptAttachmentsFromPseudoType({
      pseudoTypes: acceptedPseudoTypes,
      pseudoPost: pseudoPost.key,
      attachmentsByPseudoType,
    });

    if (canAccept) {
      if (form.pseudoType === selectedPseudoPost) {
        const hasUploadedPhoto = form.attachments?.cards?.length > 0;

        if (hasUploadedPhoto) {
          return form.attachments?.cards ?? [];
        }
      }
      return attachmentsByPseudoType[selectedPseudoPost]?.cards ?? [];
    }
    return attachmentsByPseudoType[pseudoPost.key]?.cards ?? [];
  };
